module.exports = {
  RECT: '0',
  CIRCLE: '1',
  ROUND: '2',
  EXTRA_ROUND: '3',
  RANDOM_CIRCLE: '4',
  SMALL_CIRCLE: '5',
  SMALL_RECT: '6',
  RHOMBUS: '7',
  HORIZONTAL_ROUND: '8',
  VERTICAL_ROUND: '9',
  BUBBLES: '10',
  IMAGE: '11',
  LINE: '12',
  OVER_ROUND: '13',
  TEST: '14',
  // IMAGE_FILL: '12',
  // RES_IMAGE: '13',
}